// extracted by mini-css-extract-plugin
module.exports = {"h1":"style_h1__2Lw-p","genericButton":"style_genericButton__21qOJ","button":"style_button__325iw","publish":"style_publish__2GpVB"};